import React, { useState, useEffect } from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { exerciseOptions, fetchData } from '../utils/fetchData';
import HorizontalScrollBar from './HorizontalScrollBar';

const SearchExercises = ({ setExercises, bodyPart, setBodyPart }) => {
  const [search, setSearch] = useState('');
  const [bodyParts, setBodyParts] = useState([]);

  useEffect(() => {
    const fetchExercisesData = async () => {
      const bodyPartsData = await fetchData(
        'https://exercisedb.p.rapidapi.com/exercises/bodyPartList',
        exerciseOptions
      );

      setBodyParts(['all', ...bodyPartsData]);
    };

    fetchExercisesData();
  }, []);

  const handleSearch = async () => {
    if (search) {
      const exercisesData = await fetchData(
        'https://exercisedb.p.rapidapi.com/exercises',
        exerciseOptions
      );

      const serchedExercises = exercisesData.filter(
        (exercise) =>
          exercise.name.toLowerCase().includes(search) ||
          exercise.target.toLowerCase().includes(search) ||
          exercise.equipment.toLowerCase().includes(search) ||
          exercise.bodyPart.toLowerCase().includes(search)
      );

      setSearch('');
      setExercises(serchedExercises);
    }
  };

  return (
    <>
      <Stack
        id="search"
        alignItems="center"
        mt="100px"
        mb="100px"
        justifyContent="center"
        p="20px"
      >
        <Typography
          fontWeight={700}
          sx={{ fontSize: { lg: '44px', xs: '30px' } }}
          mb="50px"
          textAlign="center"
          color="#fed136"
        >
          Exercises you should know<span style={{ color: 'red' }}>.</span>
        </Typography>

        <Box position="relative" mb="72px">
          <TextField
            sx={{
              input: {
                fontWeight: '700',
                border: 'none',
                borderRadius: '4px',
              },
              width: { lg: '800px', xs: '350px' },
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
            height="76px"
            value={search}
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
            placeholder="Search"
            type="text"
          />
          <Button
            variant="contained"
            color="error"
            sx={{
              backgroundColor: '#FF2625',
              color: '#fff',
              texttransform: 'none',
              width: { lg: '175px', xs: '80px' },
              fontSize: { lg: '20px', xs: '14px' },
              height: '56px',
              position: 'absolute',
              right: 0,
            }}
            onClick={handleSearch}
          >
            Search
          </Button>
        </Box>

        <Box sx={{ position: 'relative', width: '100%', p: '20px' }}>
          <HorizontalScrollBar
            data={bodyParts}
            bodyPart={bodyPart}
            setBodyPart={setBodyPart}
            isBodyParts
          />
        </Box>
      </Stack>
    </>
  );
};

export default SearchExercises;
